import { render, staticRenderFns } from "./LinkBubble.vue?vue&type=template&id=6769d1e4&scoped=true&lang=pug&"
import script from "./LinkBubble.vue?vue&type=script&lang=ts&"
export * from "./LinkBubble.vue?vue&type=script&lang=ts&"
import style0 from "./LinkBubble.vue?vue&type=style&index=0&id=6769d1e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6769d1e4",
  null
  
)

export default component.exports